/**
 * Проверяет, указана ли площадь в поиске
 */
import { IJsonQuery } from '@cian/api-models/common/json_query';

export function hasArea(jsonQuery: IJsonQuery): boolean {
  return jsonQuery.site !== undefined || jsonQuery.total_area !== undefined;
}
